import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';
import Loader from '../Loader/Loader';
import Navbar from '../../component/Navbar/navbar.js';
import Footer from '../../component/Footer/footer.js';
import CookieModal from '../../component/cookieModal.js';
import "../../../node_modules/react-modal-video/css/modal-video.css";
import { product_category } from '../../axios/api/product_category.js';
import TinySlider from 'tiny-slider-react';
import "tiny-slider/dist/tiny-slider.css";
import Cookies from "universal-cookie";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import Slider from "react-slick";


import {baseurl, apikey, domain } from '../../baseurl';


import axios from 'axios';

import SimpleImageSlider from "react-simple-image-slider";


import { useSelector, useDispatch } from 'react-redux';

const settings = {
    container: '.tiny-single-item',
    items: 2,
    controls: false,
    mouseDrag: true,
    loop: true,
    rewind: true,
    autoplay: true,
    autoplayButtonOutput: false,
    autoplayTimeout: 3000,
    navPosition: "bottom",
    speed: 400,
    gutter: 16,
}

const settingsBanner = {
    items: 1,
    controls: false,
    mouseDrag: true,
    loop: true,
    rewind: false,
    autoplay: true,
    autoplayButtonOutput: false,
    autoplayTimeout: 3000,
    nav: true,
    navPosition: "bottom",
    speed: 600,
};



export default function IndexLandingFour() {
    const [getRes, setGetRes] = useState(null);
    const [loading, setLoading] = useState(true);
    const response = useSelector((state) => state.websiteReducer);
    const [sectionsArray, setSectionsArray] = useState();
    const [webData, setWebData] = useState();
    const [currentBanner, setCurrentBanner] = useState(0);
    const cookie = new Cookies();
    const [siteData, setSiteData] = useState();

    const dispatch = useDispatch();

    const [imgBanners,setImagesBanner] = useState([]);



      useEffect(() => {


       

        if (response && response.data && response.data.data) {

            //console.log(response);
            setWebData(response.data.data);
            setSectionsArray(response.data.data.home_sections);
            setLoading(false); // Set loading to false when data is fetched
        }

        if(cookie.get('icp_favicon'))
        {
             setSiteData(cookie.get("icp_favicon"));
        }


      }, [response]);

      useEffect(()=>{ banner();},[])


      useEffect(() => {

        const res = async ()=>{
            const result = await product_category();
            //console.log(result);

                if(result.status === 200)
                {
                    if(result.data.status === 1)
                    {

                        setGetRes(result.data.data);
                       // console.log(result.data.data);

                    }
                }
                else
                {
                    if(result.response.data.status === 0)
                    {
                       // let msg = result.response.data.message;

                       // console.log(msg);


                    }
                }
        }

        res();
        //console.log(webData);

      }, []);




      const banner = ()=>{

        let config = {
        method: 'get',
        maxBodyLength: Infinity,
        url: baseurl+'/banners',
        headers: {
            'apikey': apikey,
            'domain': domain
        }
        };

        axios.request(config)
        .then((response) => {

            if(response.data.status == '1')
            {
                console.log(response.data.data);
                setImagesBanner(response.data.data);
            }
        })
        .catch((error) => {
        //console.log(error);
        });

    }

    const BannerSlider = ({ images }) => {
        const [current, setCurrent] = useState(0);
        const [isPaused, setIsPaused] = useState(false);

            const nextSlide = () => {
                if (!images || images.length === 0) return;

                setCurrent((prev) =>
                    prev === images.length - 1 ? 0 : prev + 1
                );
            };

            const prevSlide = () => {
                if (!images || images.length === 0) return;

                setCurrent((prev) =>
                    prev === 0 ? images.length - 1 : prev - 1
                );
            };

            useEffect(() => {
                if (!images || images.length <= 1 || isPaused) return;

                const timer = setInterval(() => {
                    setCurrent((prev) =>
                        prev === images.length - 1 ? 0 : prev + 1
                    );
                }, 3000);

                return () => clearInterval(timer);
            }, [images, isPaused]);

            if (!images || images.length === 0) {
                return null;
            }

            return (
                <div
                    className="relative w-full h-screen overflow-hidden bg-black group"
                    onMouseEnter={() => setIsPaused(true)}
                    onMouseLeave={() => setIsPaused(false)}
                >

                    {/* Slides */}
                    <div className="relative w-full h-full">

                        {images.map((image, index) => (
                            <div
                                key={index}
                                className={`
                                    absolute inset-0
                                    w-full h-full
                                    transition-opacity duration-700 ease-in-out
                                    ${index === current
                                        ? "opacity-100 z-10"
                                        : "opacity-0 z-0 pointer-events-none"
                                    }
                                `}
                            >
                                <div className="w-full h-full flex items-center justify-center">
                                    <img
                                        src={image}
                                        alt={`Banner ${index + 1}`}
                                        className="
                                            w-full
                                            h-full
                                            object-contain
                                            select-none
                                        "
                                        draggable="false"
                                    />
                                </div>
                            </div>
                        ))}

                    </div>

                    {/* Previous Button */}
                    {images.length > 1 && (
                        <button
                            type="button"
                            onClick={prevSlide}
                            className="
                                absolute
                                left-4
                                top-1/2
                                -translate-y-1/2
                                z-20
                                w-11
                                h-11
                                rounded-full
                                bg-black/40
                                hover:bg-black/70
                                text-white
                                flex
                                items-center
                                justify-center
                                transition-all
                                duration-300
                                opacity-0
                                group-hover:opacity-100
                                backdrop-blur-sm
                            "
                            aria-label="Previous banner"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth="2"
                                stroke="currentColor"
                                className="w-6 h-6"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M15.75 19.5L8.25 12l7.5-7.5"
                                />
                            </svg>
                        </button>
                    )}

                    {/* Next Button */}
                    {images.length > 1 && (
                        <button
                            type="button"
                            onClick={nextSlide}
                            className="
                                absolute
                                right-4
                                top-1/2
                                -translate-y-1/2
                                z-20
                                w-11
                                h-11
                                rounded-full
                                bg-black/40
                                hover:bg-black/70
                                text-white
                                flex
                                items-center
                                justify-center
                                transition-all
                                duration-300
                                opacity-0
                                group-hover:opacity-100
                                backdrop-blur-sm
                            "
                            aria-label="Next banner"
                        >
                            <svg
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 24 24"
                                strokeWidth="2"
                                stroke="currentColor"
                                className="w-6 h-6"
                            >
                                <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    d="M8.25 4.5l7.5 7.5-7.5 7.5"
                                />
                            </svg>
                        </button>
                    )}

                    {/* Dots */}
                    {images.length > 1 && (
                        <div
                            className="
                                absolute
                                bottom-6
                                left-1/2
                                -translate-x-1/2
                                z-20
                                flex
                                items-center
                                gap-2
                            "
                        >
                            {images.map((_, index) => (
                                <button
                                    key={index}
                                    type="button"
                                    onClick={() => setCurrent(index)}
                                    className={`
                                        h-2.5
                                        rounded-full
                                        transition-all
                                        duration-300
                                        ${
                                            index === current
                                                ? "w-8 bg-white"
                                                : "w-2.5 bg-white/50 hover:bg-white/80"
                                        }
                                    `}
                                    aria-label={`Go to banner ${index + 1}`}
                                />
                            ))}
                        </div>
                    )}

                    {/* Slide Counter */}
                    {images.length > 1 && (
                        <div
                            className="
                                absolute
                                top-5
                                right-5
                                z-20
                                px-3
                                py-1.5
                                rounded-full
                                bg-black/40
                                text-white
                                text-sm
                                backdrop-blur-sm
                            "
                        >
                            {current + 1} / {images.length}
                        </div>
                    )}

                </div>
            );
        };



      if (loading) {
        return (
            <Loader />

          );
      }




    const Category = ({data})=>{
        const design = (
            <>
                 <Link to={"/category/"+data.slug}><div className="group p-6 md:px-4 rounded-lg shadow dark:shadow-gray-800 hover:shadow-md dark:hover:shadow-gray-700 bg-white dark:bg-slate-900 text-center transition-all duration-500 ease-in-out">
                            <div className="size-16 bg-indigo-600/5 text-indigo-600 rounded-lg text-2xl flex align-middle justify-center items-center shadow-sm dark:shadow-gray-800 mx-auto">
                                  <img src={data ? data.image :'images/course/icon1.png'} alt="" className='appIcon'/>
                            </div>

                            <div className="content mt-7">
                                <Link to={"/category/"+data.slug} className="title h5 text-lg font-medium hover:text-indigo-600">{data.name}</Link>
                                <p className="text-slate-400 mt-3"></p>

                                {/* <div className="mt-5">
                                    <Link to="#" className="relative inline-flex items-center font-semibold tracking-wide align-middle text-base text-center border-none after:content-[''] after:absolute after:h-px after:w-0 hover:after:w-full after:end-0 hover:after:end-auto after:bottom-0 after:start-0 after:duration-500 text-indigo-600 hover:text-indigo-600 after:bg-indigo-600 duration-500">Read More <div className="ms-2 text-[10px]"/></Link>
                                </div> */}
                            </div>
                        </div>
                     </Link>
            </>
        );

        return design;
    }

    const AboutUs = React.memo(()=>{
        const design = (
            <>
                <section className="relative  dark:bg-slate-800 ">
                    <div className="container relative ">
                        <div className="grid md:grid-cols-12 grid-cols-1 items-center gap-[30px]">
                            <div className="md:col-span-6  p-5 pt-16 pb-9 rounded-xl">
                                <div className="">
                                    {/* <h6 className="text-indigo-600 text-sm font-bold uppercase mb-2">About Us</h6> */}
                                    <h3 className="mb-4 md:text-4xl md:leading-normal text-3xl leading-normal font-bold ">Our Philosophy </h3>
                                    {/* <h1 className="font-bold lg:leading-normal  leading-normal text-2xl lg:text-3xl mb-5"></h1> */}
                                    <p className="text-slate-400 max-w-xl ">Breaking the stigma that learning and studying is boring. </p>
                                  <ul class="list-none text-slate-400 mt-4">
                                    <li class="mb-1 flex items-center m-0">
                                        <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" class="text-indigo-600 text-base me-2" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path><path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05"></path></svg> 
                                        Understand rather than resort to rote learning
                                    </li>

                                    <li class="mb-1 flex items-center m-0">
                                        <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" class="text-indigo-600 text-base me-2" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path><path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05"></path></svg> 
                                       Learn at your own pace and time
                                    </li>

                                    <li class="mb-1 flex items-center m-0">
                                        <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" class="text-indigo-600 text-base me-2" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path><path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05"></path></svg> 
                                       Complex content made easy
                                    </li>

                                    <li class="mb-1 flex items-center m-0">
                                        <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" class="text-indigo-600 text-base me-2" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path><path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05"></path></svg> 
                                        Explore school content in an all new fun way
                                    </li>

                                    <li class="mb-1 flex items-center m-0">
                                        <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" class="text-indigo-600 text-base me-2" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path><path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05"></path></svg> 
                                        Visualize and learn
                                    </li>
                                    <li class="mb-1 flex items-center m-0">
                                        <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" class="text-indigo-600 text-base me-2" height="1em" width="1em" xmlns="http://www.w3.org/2000/svg"><path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path><path d="m10.97 4.97-.02.022-3.473 4.425-2.093-2.094a.75.75 0 0 0-1.06 1.06L6.97 11.03a.75.75 0 0 0 1.079-.02l3.992-4.99a.75.75 0 0 0-1.071-1.05"></path></svg>
                                         Learning made easy and fun
                                    </li>
                                  </ul>
                                </div>
                            </div>
                            <div className='md:col-span-6 p-4'>
                                <div className="relative">
                                    <img src='images/philosophy.png' className="rounded-xl" alt="" style={{width:'100%',objectFit:'cover'}}/>

                                    <div className="absolute bottom-24 end-0">
                                        {/* <img src='images/course/application2.jpg' className="rounded-md shadow-md size-80" alt="" style={{objectFit:'cover'}}/> */}
                                        
                                    </div>
                                </div>
                            </div>

                            

                            
                        </div>
                    </div>
                </section>
            </>
        );

        return design;
    })

    const PopularCourses = React.memo(()=>{
        return (
            <>
                <section className="relative py-16 overflow-hidden" id="courses">
                    <div className="container relative">
                        <div className="grid grid-cols-1 pb-8 text-center">
                            <h3 className="mb-4 md:text-3xl md:leading-normal text-2xl leading-normal font-semibold">Courses</h3>
                            <p className="text-slate-400 max-w-xl mx-auto">[India’s Most Affordable Courses]</p>
                        </div>

                        <div className="grid grid-cols-1 lg:grid-cols-3 md:grid-cols-2 mt-8 gap-[30px]">

                            { webData ?
                                 [...webData.popular_courses ]
                                .sort((a, b) => {
                                // Extract class numbers from product names
                                const getClassNumber = (name) => {
                                    const match = name.match(/CLASS\s*(\d+)/i) || name.match(/\b(\d+)\b/);
                                    return match ? parseInt(match[1]) : 0;
                                };
                                
                                const getBoardPriority = (name) => {
                                    // MH BOARD comes after regular classes
                                    if (name.toLowerCase().includes('mh board')) return 2;
                                    if (name.toLowerCase().includes('class')) return 1;
                                    return 3;
                                };
                                
                                const aBoard = getBoardPriority(a.product_name);
                                const bBoard = getBoardPriority(b.product_name);
                                
                                // First sort by board type
                                if (aBoard !== bBoard) {
                                    return aBoard - bBoard;
                                }
                                
                                // Then sort by class number (ascending)
                                const aClass = getClassNumber(a.product_name);
                                const bClass = getClassNumber(b.product_name);
                                return aClass - bClass;
                            }).map((item,index)=>{
                                    return (
                                        <div key={index} className="group relative rounded-md shadow hover:shadow-lg dark:shadow-gray-800 duration-500 ease-in-out overflow-hidden">

                                            <Link to={"/course/"+item.slug}>
                                                <div className="relative overflow-hidden">
                                                    <div className="flex justify-center py-3">
                                                        <img src={item.image} className="group-hover:scale-110 duration-500 ease-in-out" alt="course_img" width="110"/>
                                                    </div>
                                                    
                                                    <div className="absolute inset-0 bg-slate-900/50 opacity-0 group-hover:opacity-100 duration-500 ease-in-out"></div>

                                                    <div className="absolute start-0 bottom-0 opacity-0 group-hover:opacity-100 duration-500 ease-in-out">
                                                        <div className="pb-4 ps-4 flex items-center">

                                                        </div>
                                                    </div>
                                                </div>
                                            </Link>
                                            <div className="content p-6 relative flex justify-center">
                                                <div>                                                    
                                                    {/* <Link to={"/course/"+item.slug} className="font-medium block text-indigo-600 text-center">{item.main_category}</Link> */}
                                                    <Link to={"/course/"+item.slug} className="text-lg font-medium block hover:text-indigo-600 duration-500 ease-in-out mt-2 text-center"> {item.product_name}</Link>
                                                    <Link to={"/course/"+item.slug} type="submit" id="submitsubscribe" name="send" className=" mt-5 py-2 px-5 inline-block font-semibold tracking-wide border align-middle duration-500 text-base text-center bg-indigo-600 hover:bg-indigo-700 border-indigo-600 hover:border-indigo-700 text-white rounded-md">Buy now</Link>
                                                </div>                                                
                                                    
                                                
                                            </div>

                                        </div>
                                    )
                                })
                                : null
                            }

                        </div>

                    </div>
                </section>
            </>
        );
    })



    const PopularBooks = React.memo(()=>{
        return (
            <>
                <section className="relative md:py-24 py-16 overflow-hidden" id="books">
                    <div className="container relative">
                        <div className="grid grid-cols-1 pb-8 text-center">
                            <h3 className="mb-4 md:text-3xl md:leading-normal text-2xl leading-normal font-semibold">Popular Books</h3>
                            <p className="text-slate-400 max-w-xl mx-auto">Explore Our Comprehensive CA Exam Preparation Programs"</p>
                        </div>

                        <div className="grid grid-cols-1 lg:grid-cols-3 md:grid-cols-2 mt-8 gap-[30px]">

                            { webData ?
                                webData.popular_books.map((item,index)=>{
                                    return (
                                        <div key={index} className="group relative rounded-md shadow hover:shadow-lg dark:shadow-gray-800 duration-500 ease-in-out overflow-hidden">

                                            <Link to={"/course/"+item.slug}>
                                                <div className="relative overflow-hidden">
                                                    <img src={item.image} className="group-hover:scale-110 duration-500 ease-in-out" alt="course_img"/>
                                                    <div className="absolute inset-0 bg-slate-900/50 opacity-0 group-hover:opacity-100 duration-500 ease-in-out"></div>

                                                    <div className="absolute start-0 bottom-0 opacity-0 group-hover:opacity-100 duration-500 ease-in-out">
                                                        <div className="pb-4 ps-4 flex items-center">

                                                        </div>
                                                    </div>
                                                </div>
                                            </Link>
                                            <div className="content p-6 relative">
                                            <Link to={"/course/"+item.slug} className="font-medium block text-indigo-600">{item.main_category}</Link>
                                                <Link to={"/course/"+item.slug} className="text-lg font-medium block hover:text-indigo-600 duration-500 ease-in-out mt-2"> {item.product_name}</Link>
                                                <Link to={"/course/"+item.slug} type="submit" id="submitsubscribe" name="send" className=" mt-5 py-2 px-5 inline-block font-semibold tracking-wide border align-middle duration-500 text-base text-center bg-indigo-600 hover:bg-indigo-700 border-indigo-600 hover:border-indigo-700 text-white rounded-md">Buy now</Link>
                                                <div className="absolute -top-7 end-6 z-1 price_btn group-hover:opacity-100 duration-500 ease-in-out d-block"  >
                                                  
                                                </div>
                                            </div>

                                        </div>
                                    )
                                })
                                : null
                            }

                        </div>

                    </div>
                </section>
            </>
        );
    })


    const Testimonial = React.memo(()=>{
        return (
            <>
                {/* <section className="relative md:py-24 py-16 overflow-hidden">
                    <div className="container relative">
                        <div className="grid grid-cols-1 pb-8 text-center">
                            <h3 className="mb-6 md:text-3xl text-2xl md:leading-normal leading-normal font-semibold">Our Community</h3>

                            <p className="text-slate-400 max-w-xl mx-auto">See What Our Students Have to Say!!</p>
                        </div>
                        <div className="flex justify-center">
                            <div className="grid grid-cols-2 lg:grid-cols-1 md:grid-cols-1 mt-8 gap-[30px] ">


                                        <TinySlider settings={settings}>
                                        {

                                            webData ? webData.testimonials.map((item, index) => {
                                                return (
                                                    <div className="tiny-slide tiny-single-item" key={index}>
                                                        <div className="grid gird-cols-1 p-6 lg:p-0 relative rounded-md shadow dark:shadow-gray-800 overflow-hidden m-2">
                                                            <div className="flex justify-start items-center gap-4 p-6">
                                                                <div>
                                                                    <img className="lg:rounded-full rounded-full mx-auto h-24 w-24" src={item.image ? item.image : ''} alt="student" />
                                                                </div>
                                                                <div>
                                                                    <span className="text-indigo-600 block mb-1">{item.username}</span>
                                                                    <span className="text-slate-400 text-sm dark:text-white/60 block">{item.designation}</span>
                                                                </div>
                                                            </div>
                                                            <div className="pt-6 lg:p-6 text-center lg:text-start space-y-4">
                                                                <p className="text-base text-slate-400">{item.text}</p>

                                                                <div className="rating">
                                                                    {Array.from({ length: 5 }, (v, i) => (
                                                                        <span key={i} style={{ color: i < item.rating ? '#ff0000' : '#cccccc' }}>
                                                                            &#10084; 
                                                                        </span>
                                                                    ))}
                                                                </div>


                                                            </div>
                                                        </div>
                                                    </div>
                                                )
                                            })
                                            : null
                                        }
                                        </TinySlider>


                            </div>
                        </div>


                    </div>
                </section> */}
            </>
        );
    })

    // const Instructor = React.memo(()=>{
    //     return (
    //         <>
    //             <div className="container relative md:mt-24 mt-16 mb-12" id="Instructors">
    //                 <div className="grid grid-cols-1 pb-8 text-center">
    //                     <h3 className="mb-6 md:text-3xl text-2xl md:leading-normal leading-normal font-semibold">Our Instructor</h3>

    //                     <p className="text-slate-400 max-w-xl mx-auto">Meet Our Experienced Faculty Dedicated to Your Success</p>
    //                 </div>

    //                 <div className="grid md:grid-cols-12 grid-cols-1 mt-8 gap-[30px] our-instructor">
    //                     <div className="lg:col-span-3  m-auto justify-content-center">
    //                         <div className="group text-center">
    //                             <div className="relative inline-block mx-auto size-52 rounded-full overflow-hidden">
    //                                 <img src="images/instructor/123.jpeg" className="" alt=""/>


    //                                 <div className="absolute inset-0 bg-gradient-to-b from-transparent to-black size-52 rounded-full opacity-0 group-hover:opacity-100 duration-500"></div>
    //                             </div>

    //                             <div className="content mt-3">
    //                                 <a href="/" className="text-lg font-semibold hover:text-indigo-600 duration-500"> CA Raghuram Sarma JV</a>
    //                                 <p className="text-slate-400">Faculty</p>
    //                             </div>
    //                         </div>
    //                     </div>
    //                 </div>
    //             </div>
    //         </>
    //     );
    // })


    return (
        <>
            {/* <Navbar /> */}
         <Navbar navClass="nav-sticky" />

             
            {/* <section className="relative table w-full pt-16   " id="home">
                <div className="container relative pb-24">
                    <div className="grid lg:grid-cols-12 md:grid-cols-2 mt-24 items-center gap-[30px]">
                        <div className="lg:col-span-6">
                            <h1 className="font-bold lg:leading-normal heading leading-normal text-5xl lg:text-5xl mb-5">Learning experience at the best! </h1>
                                    <p className="text-slate-400 max-w-xl mb-4 text-justify">300+ hours of engaging video content  </p>


                            <div className="relative mt-10">
                                <Link to="/category" className="py-2 px-5 inline-block font-semibold tracking-wide border align-middle transition duration-500 ease-in-out text-base text-center bg-indigo-600 hover:bg-indigo-700 border-indigo-600 hover:border-indigo-700 text-white rounded-full me-1">Start Now</Link>
                            </div>
                        </div>


                        <div className="md:col-span-6">
                            <div className="relative">
                                <img src='images/pop-up-allpages.gif' alt="" className='rounded-xl'/>
                            </div>
                        </div>

                        <div className="overflow-hidden after:content-[''] after:absolute after:size-32 after:bg-indigo-600/5 after:top-10 after:start-0 after:-z-1 after:rounded-3xl after:animate-[spin_10s_linear_infinite]"></div>
                        <div className="overflow-hidden after:content-[''] after:absolute after:size-[512px] after:bg-indigo-600/5 after:top-0 after:-end-5 after:-z-1 after:rounded-full"></div>
                    </div>
                </div>

               

                <div className="container relative">
                    <div className="grid lg:grid-cols-12 md:grid-cols-2 mt-16 items-center gap-[30px]">
                        <div className="md:col-span-6">
                            <div className="relative">
                                <img src='images/img11.png' alt="" />
                            </div>
                        </div>

                        <div className="lg:col-span-6">
                             <h3 className="mb-4 md:text-3xl md:leading-normal text-2xl leading-normal font-semibold">Learning made easy!</h3>

                            <p className="text-slate-400 text-lg max-w-xl text-justify width90">Watch lectures, notes and practice questions and take tests on the go.</p>
                             <h6 className="text-indigo-600 text-sm font-bold uppercase mb-2 mt-5">Get SMS link to download the app</h6>
                            <form>
                                <div className="grid lg:grid-cols-12 md:grid-cols-2  items-center gap-[30px]">
                                    <div className="lg:col-span-6">
                                        <input className='form-input mt-3 w-full py-2 px-3 h-10 bg-transparent dark:bg-slate-900 dark:text-slate-200 rounded outline-none border border-gray-200 focus:border-indigo-600 dark:border-gray-800 dark:focus:border-indigo-600 focus:ring-0' placeholder='Enter Phone Number'></input>
                                    </div>

                                    <div className="lg:col-span-6">
                                        <Link to="" className="py-2 px-5 inline-block font-semibold tracking-wide border align-middle transition duration-500 ease-in-out text-base text-center bg-indigo-600 hover:bg-indigo-700 border-indigo-600 hover:border-indigo-700 text-white rounded-full me-1 mt-2">Get Link</Link>
                                    </div>
                                </div>
                                <div className='mt-7'>
                                    <a href="" data-discover="true"><img class="inline-block width40" alt="" src="images/Tutormate-GooglePlaystore.png" /></a>
                                    <a href="" data-discover="true"><img class="inline-block width40 ms-2" alt="" src="images/Tutormate-AppleStore.png" /></a>
                                </div>
                                
                            </form>

                        
                        </div>

                     </div>
                </div>
            </section> */}
            
           
            {/* Dynamic Banner Section */}
            <section
                className="relative w-full overflow-hidden bg-black"
                id="home"
            >
                {imgBanners && imgBanners.length > 0 && (
                    <BannerSlider images={imgBanners} />
                )}
            </section>



            
                <AboutUs />
            


            { <section className="relative pt-16 mt-16 pb-16 bg-gray-50 dark:bg-slate-800">
                <div className="container relative">
                    <div className="grid grid-cols-1 pb-8 text-center">
                        <h3 className="mb-4 md:text-3xl md:leading-normal text-2xl leading-normal font-semibold">Features</h3>

                        {/* <p className="text-slate-400  mx-auto">Search your future opportunity with our categories</p> */}
                    </div>
                </div>

                    <div className="container relative">
                         <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 mt-4 gap-[30px]">
                                    <div className="group p-6 rounded-lg shadow dark:shadow-gray-800 bg-white dark:bg-slate-900 hover:-translate-y-2 transition-all duration-500 ease-in-out">
                                        <div
                                            className="size-16 bg-indigo-600/5  group-hover:text-white border-2 border-indigo-600/20 text-indigo-600 rounded-lg text-2xl flex align-middle justify-center items-center shadow-sm dark:shadow-gray-800 transition-all duration-500 ease-in-out">
                                                {/* <Icons className="size-6"/> */}
                                                <img src='images/2018-07-23-1.png' className='width70'></img>
                                        </div>
            
                                        <div className="content mt-7">
                                            <Link to="/page-services" className="title h5 text-lg font-medium hover:text-indigo-600">300+ hours of video content</Link>
                                            <p className="text-slate-400 mt-3">Interesting, interactive and varied video content that ensures knowledge isn’t limited to the classroom</p>
            
                                            
                                        </div>
                                    </div>

                                    <div className="group p-6 rounded-lg shadow dark:shadow-gray-800 bg-white dark:bg-slate-900 hover:-translate-y-2 transition-all duration-500 ease-in-out">
                                        <div
                                            className="size-16 bg-indigo-600/5  group-hover:text-white border-2 border-indigo-600/20 text-indigo-600 rounded-lg text-2xl flex align-middle justify-center items-center shadow-sm dark:shadow-gray-800 transition-all duration-500 ease-in-out">
                                                {/* <Icons className="size-6"/> */}
                                                <img src='images/2018-07-23.png' className='width70'></img>
                                        </div>
            
                                        <div className="content mt-7">
                                            <Link to="/page-services" className="title h5 text-lg font-medium hover:text-indigo-600">CBSE Notes</Link>
                                            <p className="text-slate-400 mt-3">All the important information of a textbook simplified into easily accessible, interactive notes for you to refer.</p>
            
                                            
                                        </div>
                                    </div>

                                      <div className="group p-6 rounded-lg shadow dark:shadow-gray-800 bg-white dark:bg-slate-900 hover:-translate-y-2 transition-all duration-500 ease-in-out">
                                        <div
                                            className="size-16 bg-indigo-600/5  group-hover:text-white border-2 border-indigo-600/20 text-indigo-600 rounded-lg text-2xl flex align-middle justify-center items-center shadow-sm dark:shadow-gray-800 transition-all duration-500 ease-in-out">
                                                {/* <Icons className="size-6"/> */}
                                                <img src='images/2018-07-23-2.png' className='width70'></img>
                                        </div>
            
                                        <div className="content mt-7">
                                            <Link to="/page-services" className="title h5 text-lg font-medium hover:text-indigo-600">CBSE Q’s & A’s</Link>
                                            <p className="text-slate-400 mt-3">An array of varied practice questions, with the solutions, to ensure you get all the practice you need</p>
            
                                            
                                        </div>
                                    </div>
                                
                        </div>
                    </div>
            </section> }


             { <section className="relative mt-16 pb-16 ">
                <div className="container relative">
                    <div className="grid grid-cols-1 pb-8 text-center">
                        <h3 className="mb-4 md:text-3xl md:leading-normal text-2xl leading-normal font-semibold">Exams</h3>

                        {/* <p className="text-slate-400  mx-auto">Search your future opportunity with our categories</p> */}
                    </div>
                </div>

                    <div className="container relative">
                         <div className="grid lg:grid-cols-3 md:grid-cols-2 grid-cols-1 mt-4 gap-[30px]">
                                    <div className="group p-6 rounded-lg shadow dark:shadow-gray-800 bg-white dark:bg-slate-900 hover:-translate-y-2 transition-all duration-500 ease-in-out">
                                        <div className="content mt-7">
                                            <Link to="/category" className="title h3 text-xl font-semibold text-indigo-600">CBSE Class 8 - 10</Link>
                                            <p className="text-slate-400 mt-3">In the entire rat race of schools, tuitions and coaching classes, students have no time for themselves and for recreation. We provide a one stop shop solution for all your needs with interactive content that will help you crack any high school examination, yet being affordable.</p>
            
                                            <div className='d-flex align-items-center mt-5'>
                                                <img src='images/2018-07-23-1.png' className='width15'></img>
                                                <h3 className='ms-3 text-semibold text-xl h3'>300+ hours of video</h3>
                                            </div>

                                             <div className='d-flex align-items-center mt-5'>
                                                <img src='images/2018-07-23.png' className='width15'></img>
                                                <h3 className='ms-3 text-semibold text-xl h3'>Notes on all chapters</h3>
                                            </div>

                                             <div className='d-flex align-items-center mt-5'>
                                                <img src='images/2018-07-23-2.png' className='width15'></img>
                                                <h3 className='ms-3 text-semibold text-xl h3'>Practice Questions with solutions</h3>
                                            </div>

                                            
                                        </div>

                                            <Link to="/category" className="py-2 mt-5 px-5 inline-block font-semibold tracking-wide border align-middle transition duration-500 ease-in-out text-base text-center bg-indigo-600 hover:bg-indigo-700 border-indigo-600 hover:border-indigo-700 text-white rounded-md me-1 w-full">Learn More</Link>
                                    </div>


                                     <div className="group p-6 rounded-lg shadow dark:shadow-gray-800 bg-white dark:bg-slate-900 hover:-translate-y-2 transition-all duration-500 ease-in-out">
                                        <div className="content mt-7">
                                            <Link to="/exam" className="title h3 text-xl font-semibold text-indigo-600">11 JEE</Link>
                                            <p className="text-slate-400 mt-3">Forget about the hassle of running from one coaching class to another. Give yourself the best platform to balance your high school curriculum with your JEE prep and give yourself the best shot of getting into the IIT’s with our tailor-made, exhaustive JEE content</p>
            
                                            <div className='d-flex align-items-center mt-5'>
                                                <img src='images/2018-07-23-1.png' className='width15'></img>
                                                <h3 className='ms-3 text-semibold text-xl h3'>300+ hours of video</h3>
                                            </div>

                                             <div className='d-flex align-items-center mt-5'>
                                                <img src='images/2018-07-23.png' className='width15'></img>
                                                <h3 className='ms-3 text-semibold text-xl h3'>Notes on all chapters</h3>
                                            </div>

                                             <div className='d-flex align-items-center mt-5'>
                                                <img src='images/2018-07-23-2.png' className='width15'></img>
                                                <h3 className='ms-3 text-semibold text-xl h3'>Practice Questions with solutions</h3>
                                            </div>
                                        </div>

                                            <Link to="/exam" className="py-2 mt-5 px-5 inline-block font-semibold tracking-wide border align-middle transition duration-500 ease-in-out text-base text-center bg-indigo-600 hover:bg-indigo-700 border-indigo-600 hover:border-indigo-700 text-white rounded-md me-1 w-full">Coming Soon</Link>
                                    </div>


                                     <div className="group p-6 rounded-lg shadow dark:shadow-gray-800 bg-white dark:bg-slate-900 hover:-translate-y-2 transition-all duration-500 ease-in-out">
                                        <div className="content mt-7">
                                            <Link to="/comming" className="title h3 text-xl font-semibold text-indigo-600">11 NEET</Link>
                                            <p className="text-slate-400 mt-3">Put your best foot forward and give yourself the best shot of gaining that coveted medical seat. Crack the NEET examination with our library that includes hours of content that will help you sail through.</p>
            
                                            <div className='d-flex align-items-center mt-5'>
                                                <img src='images/2018-07-23-1.png' className='width15'></img>
                                                <h3 className='ms-3 text-semibold text-xl h3'>300+ hours of video</h3>
                                            </div>

                                             <div className='d-flex align-items-center mt-5'>
                                                <img src='images/2018-07-23.png' className='width15'></img>
                                                <h3 className='ms-3 text-semibold text-xl h3'>Notes on all chapters</h3>
                                            </div>

                                             <div className='d-flex align-items-center mt-5'>
                                                <img src='images/2018-07-23-2.png' className='width15'></img>
                                                <h3 className='ms-3 text-semibold text-xl h3'>Practice Questions with solutions</h3>
                                            </div>
                                        </div>

                                            <Link to="/comming" className="py-2 mt-10 px-5 inline-block font-semibold tracking-wide border align-middle transition duration-500 ease-in-out text-base text-center bg-indigo-600 hover:bg-indigo-700 border-indigo-600 hover:border-indigo-700 text-white rounded-md me-1 w-full">Coming Soon</Link>
                                    </div>    
                        </div>
                    </div>
            </section> }


            <section className='py-9 bg-indigo-600'>
                <div className='container'>
                    <div className="grid lg:grid-cols-2 md:grid-cols-2 grid-cols-1 mt-4 gap-[30px]">
                        <div>
                            <h1 className='heading text-white'>Start your learning Journey !</h1>
                             <div className='mt-7'>
                                <a href="" data-discover="true"><img class="inline-block width40" alt="" src="images/Tutormate-GooglePlaystore.png" /></a>
                                <a href="" data-discover="true"><img class="inline-block width40 ms-2" alt="" src="images/Tutormate-AppleStore.png" /></a>
                            </div>
                        </div>

                        <div className='d-flex justify-end'>
                            <div className="lg:col-span-6">
                                <h1 className='h5 titile text-white text-md'>Get SMS link to download the app</h1>

                                <span className='d-flex'>
                                    <input className='form-input mt-3  py-2 px-3 h-10   dark:text-slate-200 rounded outline-none border border-gray-200 focus:border-indigo-600 dark:border-gray-800 dark:focus:border-indigo-600 focus:ring-0' placeholder='Enter Phone Number'></input>
                                      <div className="lg:col-span-6">
                                        <Link to="" className="py-2 px-5 inline-block font-semibold tracking-wide border align-middle transition duration-500 ease-in-out text-base text-center bg-white text-indigo-600 rounded-md me-1 mt-3 ms-3">Get Link</Link>
                                    </div>
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            

            { sectionsArray ? sectionsArray.includes('popular_courses') && (
                <PopularCourses />

            ) : ''}


            {/* <PopularBooks /> */}




            { sectionsArray ? sectionsArray.includes('testimonials') && (
                <Testimonial />
            ) : ''}




            {/* { sectionsArray ? sectionsArray.includes('instructor') && (
                <Instructor />
            ) : ''} */}




            <Footer />
            
        </>
    )
}
